export default __webpack_public_path__ + "static/media/three-dots.9931ef2e.png";